import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureDatabricksDeltaLakeCopySource } from 'app/model/pipeline/copysource/azure-databricks-delta-lake-copysource';
import { commonCopySourceAdapts, CopySourceAdapter } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from '../../value.adapter';
import { Model } from 'app/model/backendmodel';
import { LookupActivity } from 'app/model/pipeline/lookup.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDatabricksDeltaLakeCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        exportSettings: {
            type: '*',
            dateFormat: '*',
            timestampFormat: '*'
        }
    }
})
export class AzureDatabricksDeltaLakeCopySourceAdapter extends CopySourceAdapter<
    AzureDatabricksDeltaLakeCopySource,
    Model.AzureDatabricksDeltaLakeCopySource
> {
    protected override async _toResource(
        copySource: AzureDatabricksDeltaLakeCopySource
    ): Promise<Model.AzureDatabricksDeltaLakeCopySource> {
        const result = this._toTabularResource(copySource, Metamodel.modelFor(AzureDatabricksDeltaLakeCopySource).name);
        if (!(copySource.owner instanceof LookupActivity)) {
            result.exportSettings = { type: 'AzureDatabricksDeltaLakeExportCommand' };
            result.exportSettings.dateFormat =
                ValueAdapter.toResource(copySource, AzureDatabricksDeltaLakeCopySource.DATE_FORMAT) || undefined;
            result.exportSettings.timestampFormat =
                ValueAdapter.toResource(copySource, AzureDatabricksDeltaLakeCopySource.TIMESTAMP_FORMAT) || undefined;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.AzureDatabricksDeltaLakeCopySource,
        copyActivity: CopyActivity
    ): Promise<AzureDatabricksDeltaLakeCopySource> {
        const result = this._toTabularModel(resource, copyActivity, AzureDatabricksDeltaLakeCopySource.MODEL);
        const exportSettings = resource.exportSettings;
        if (exportSettings != null) {
            ValueAdapter.toModel(result, AzureDatabricksDeltaLakeCopySource.DATE_FORMAT, exportSettings.dateFormat);
            ValueAdapter.toModel(
                result,
                AzureDatabricksDeltaLakeCopySource.TIMESTAMP_FORMAT,
                exportSettings.timestampFormat
            );
        }
        return result;
    }
}
